var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLocale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_111175",
    "data-name": "Path 111175",
    d: "M-.625,1.688q-.813-1.188-2.094-3-1.563-2.25-2.062-3.031A8.8,8.8,0,0,1-5.75-6.234,5.689,5.689,0,0,1-6-8a5.791,5.791,0,0,1,.813-3A6.115,6.115,0,0,1-3-13.187,5.791,5.791,0,0,1,0-14a5.791,5.791,0,0,1,3,.813A6.115,6.115,0,0,1,5.188-11,5.791,5.791,0,0,1,6-8a5.689,5.689,0,0,1-.25,1.766,8.8,8.8,0,0,1-.969,1.891q-.5.781-2.062,3.031l-2.094,3A.717.717,0,0,1,0,2,.717.717,0,0,1-.625,1.688ZM0-5.5a2.407,2.407,0,0,0,1.766-.734A2.407,2.407,0,0,0,2.5-8a2.407,2.407,0,0,0-.734-1.766A2.407,2.407,0,0,0,0-10.5a2.407,2.407,0,0,0-1.766.734A2.407,2.407,0,0,0-2.5-8a2.407,2.407,0,0,0,.734,1.766A2.407,2.407,0,0,0,0-5.5Z",
    transform: "translate(6 14)",
    fill: "#1f423c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocale);
export default __webpack_public_path__ + "static/media/icon-locale.bf3ec581c247dc3455c1278386335219.svg";
export { ForwardRef as ReactComponent };